import './init.bdoc';
import $ from 'jquery';

console.log('jquery', $().jquery);

import 'jquery.easing';
import 'jquery-touchswipe';

import 'current-device'; // sets 'desktop' and similar classes to main html element
import './jquery.rd-navbar';
import './rd-range.min'; // extracted from core.min.js
import 'jquery-countto';
import './materialze-parallax.min';
import './jquery.ui.totop';

const userAgent = navigator.userAgent.toLowerCase(),
    initialDate = new Date(),

    $document = $(document),
    $window = $(window),
    $html = $("html"),

    isDesktop = $html.hasClass("desktop"),
    isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
    isIE = userAgent.indexOf("msie") !== -1 ? parseInt(userAgent.split("msie")[1]) : userAgent.indexOf("trident") !== -1 ? 11 : userAgent.indexOf("edge") !== -1 ? 12 : false,
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isNoviBuilder = false;

const plugins = {
    bootstrapTooltip: $("[data-toggle='tooltip']"),
    bootstrapModalDialog: $('.modal'),
    bootstrapTabs: $(".tabs-custom"),
    rdNavbar: $(".rd-navbar"),
    mfp: $('[data-lightbox]').not('[data-lightbox="gallery"] [data-lightbox]'),
    mfpGallery: $('[data-lightbox^="gallery"]'),
    statefulButton: $('.btn-stateful'),
    popover: $('[data-toggle="popover"]'),
    viewAnimate: $('.view-animate'),
    lightGallery: $("[data-lightgallery='group']"),
    lightGalleryItem: $("[data-lightgallery='item']"),
    lightDynamicGalleryItem: $("[data-lightgallery='dynamic']"),
    customToggle: $("[data-custom-toggle]"),
    counter: $(".counter"),
    progressLinear: $(".progress-linear"),
    circleProgress: $(".progress-bar-circle"),
    dateCountdown: $('.DateCountdown'),
    selectFilter: $("select.enable-select2"), // Edit: do not enhance EVERY select box, but only the ones explicitly enabled via class ".enable-select2"
    vide: $(".vide_bg"),
    slick: $('.slick-slider'),
    calendar: $(".rd-calendar"),
    rdRange: $('.rd-range'),
    customWaypoints: $('[data-custom-scroll-to]'),
    materialParallax: $(".parallax-container"),
    wow: $(".wow"),
};

/**
 * Page loader
 * @description Enables Page loader
 */
$window.on('load', function () {
    // #page-loader is added dynamically on page load, so we must select it only after it has been added.
    var pageLoader = $("#page-loader");
    if (pageLoader.length > 0 && !isNoviBuilder) {
        pageLoader.fadeOut('slow');
        $window.trigger("resize");
    } else {
        pageLoader.remove();
    }
});

/**
 * Initialize All Scripts
 */
$(function () {

    /**
     * isScrolledIntoView
     * @description  check the element whas been scrolled into the view
     */
    function isScrolledIntoView(elem) {
        if (!isNoviBuilder) {
            return elem.offset().top + elem.outerHeight() >= $window.scrollTop() && elem.offset().top <= $window.scrollTop() + $window.height();
        } else {
            return true;
        }
    }

    /**
     * Init Bootstrap tooltip
     * @description  calls a function when need to init bootstrap tooltips
     */
    function initBootstrapTooltip(tooltipPlacement) {
        if (window.innerWidth < 576) {
            plugins.bootstrapTooltip.tooltip('dispose');
            plugins.bootstrapTooltip.tooltip({
                placement: 'bottom'
            });
        } else {
            plugins.bootstrapTooltip.tooltip('dispose');
            plugins.bootstrapTooltip.tooltip({
                placement: tooltipPlacement || 'top'
            });
        }
    }

    /**
     * Copyright Year
     * @description  Evaluates correct copyright year
     */
    function initializeCopyrightYear() {
        const o = $("#copyright-year");
        if (o.length) {
            o.text(initialDate.getFullYear());
        }
    }

    initializeCopyrightYear();

    function initializeBrowserClasses() {
        /**
         * Is Mac os
         * @description  add additional class on html if mac os.
         */
        if (navigator.platform.match(/(Mac)/i)) {
            $html.addClass("mac-os");
        }

        /**
         * Is Firefox
         * @description  add additional class on html if mac os.
         */
        if (isFirefox) $html.addClass("firefox");

        /**
         * IE Polyfills
         * @description  Adds some loosing functionality to IE browsers
         */
        if (isIE) {
            if (isIE < 10) {
                $html.addClass("lt-ie-10");
            }

            if (isIE < 11) {
                $("html").addClass("ie-10");
            }

            if (isIE === 11) {
                $("html").addClass("ie-11");
            }

            if (isIE === 12) {
                $("html").addClass("ie-edge");
            }
        }
    }

    initializeBrowserClasses();


    /**
     * Bootstrap Tooltips
     * @description Activate Bootstrap Tooltips
     */
    if (plugins.bootstrapTooltip.length) {
        console.info("init legacy-bootstrap tooltip", window.location.href, plugins.bootstrapTooltip)
        const tooltipPlacement = plugins.bootstrapTooltip.attr('data-placement');
        initBootstrapTooltip(tooltipPlacement);
        $(window).on('resize orientationchange', function () {
            initBootstrapTooltip(tooltipPlacement);
        })
    }

    /**
     * Popovers
     * @description Enables Popovers plugin
     */
    if (plugins.popover.length) {
        console.info("init legacy-bootstrap popover", window.location.href, plugins.popover)

        if (window.innerWidth < 767) {
            plugins.popover.attr('data-placement', 'bottom');
            plugins.popover.popover();
        } else {
            plugins.popover.popover();
        }
    }

    /**
     * Bootstrap Buttons
     * @description  Enable Bootstrap Buttons plugin
     */
    if (plugins.statefulButton.length) {
        console.error('plugin "statefulButton" was removed', window.location.href, plugins.statefulButton)
    }

    /**
     * UI To Top
     * @description Enables ToTop Button
     */
    if (isDesktop && !isNoviBuilder) {
        $().UItoTop({
            easingType: 'easeOutQuart',
            containerClass: 'ui-to-top'
        });
    }


    /**
     * RD Navbar
     * @description Enables RD Navbar plugin
     */
    if (plugins.rdNavbar.length) {
        const aliaces = ["-", "-sm-", "-md-", "-lg-", "-xl-", "-xxl-"];
        const values = [0, 576, 768, 992, 1200, 1600];
        const len = values.length;
        const responsiveNavbar = {};

        for (let i = 0, j = 0; j < len; i = ++j) {
            if (!responsiveNavbar[values[i]]) {
                responsiveNavbar[values[i]] = {};
            }
            if (plugins.rdNavbar.attr('data' + aliaces[i] + 'layout')) {
                responsiveNavbar[values[i]].layout = plugins.rdNavbar.attr('data' + aliaces[i] + 'layout');
            }
            if (plugins.rdNavbar.attr('data' + aliaces[i] + 'device-layout')) {
                responsiveNavbar[values[i]]['deviceLayout'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'device-layout');
            }
            if (plugins.rdNavbar.attr('data' + aliaces[i] + 'hover-on')) {
                responsiveNavbar[values[i]]['focusOnHover'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'hover-on') === 'true';
            }
            if (plugins.rdNavbar.attr('data' + aliaces[i] + 'auto-height')) {
                responsiveNavbar[values[i]]['autoHeight'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'auto-height') === 'true';
            }
            if (isNoviBuilder) {
                responsiveNavbar[values[i]]['stickUp'] = false;
            } else if (plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up')) {
                responsiveNavbar[values[i]]['stickUp'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up') === 'true';
            }

            if (plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up-offset')) {
                responsiveNavbar[values[i]]['stickUpOffset'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up-offset');
            }
        }


        plugins.rdNavbar.RDNavbar({
            anchorNav: !isNoviBuilder,
            stickUpClone: (plugins.rdNavbar.attr("data-stick-up-clone") && !isNoviBuilder) ? plugins.rdNavbar.attr("data-stick-up-clone") === 'true' : false,
            responsive: responsiveNavbar,
            callbacks: {
                onStuck: function () {
                    const navbarSearch = this.$element.find('.rd-search input');

                    if (navbarSearch) {
                        navbarSearch.val('').trigger('propertychange');
                    }
                },
                onDropdownOver: function () {
                    return !isNoviBuilder;
                },
                onUnstuck: function () {
                    if (this.$clone === null)
                        return;

                    const navbarSearch = this.$clone.find('.rd-search input');

                    if (navbarSearch) {
                        navbarSearch.val('').trigger('propertychange');
                        navbarSearch.trigger('blur');
                    }

                }
            }
        });


        if (plugins.rdNavbar.attr("data-body-class")) {
            document.body.className += ' ' + plugins.rdNavbar.attr("data-body-class");
        }
    }

    /**
     * ViewPort Universal
     * @description Add class in viewport
     */
    if (plugins.viewAnimate.length) {
        console.error('plugin "viewAnimate" was removed', window.location.href, plugins.viewAnimate)
    }

    /**
     * TimeCircles
     * @description  Enable TimeCircles plugin
     */
    if (plugins.dateCountdown.length) {
        console.error('plugin "dateCountdown" was removed', window.location.href, plugins.dateCountdown)
    }

    /**
     * WOW
     * @description Enables Wow animation plugin
     */
    if ($html.hasClass("wow-animation") && plugins.wow.length && !isNoviBuilder && isDesktop) {
        console.error('WOW was removed', window.location.href, plugins.wow)
    }

    /**
     * Bootstrap tabs
     * @description Activate Bootstrap Tabs
     */
    if (plugins.bootstrapTabs.length) {
        console.error('bootstrapTabs were removed (use bootstrap v5 features instead)', window.location.href, plugins.bootstrapTabs)
    }

    // lightGallery
    if (plugins.lightGallery.length) {
        console.error('lightGallery was removed', window.location.href, plugins.lightGallery)
    }

    // lightGallery item
    if (plugins.lightGalleryItem.length) {
        console.error('lightGallery was removed', window.location.href, plugins.lightGalleryItem)
    }

    // Dynamic lightGallery
    if (plugins.lightDynamicGalleryItem.length) {
        console.error('lightGallery was removed', window.location.href, plugins.lightDynamicGalleryItem)
    }

    /**
     * Custom Toggles
     */
    if (plugins.customToggle.length) {
        console.error('customToggle feature was removed', window.location.href, plugins.customToggle)
    }
    /**
     * jQuery Count To
     * @description Enables Count To plugin
     */
    if (plugins.counter.length) {
        // we still use counters for the QA overview page (as of now)
        for (let i = 0; i < plugins.counter.length; i++) {
            const $counterNotAnimated = $(plugins.counter[i]).not('.animated');
            $document
                .on("scroll", (function () {
                    const $this = this;

                    if ((!$this.hasClass("animated")) && (isScrolledIntoView($this))) {
                        $this.countTo({
                            refreshInterval: 40,
                            from: 0,
                            to: parseInt($this.text(), 10),
                            speed: $this.attr("data-speed") || 1000
                        });
                        $this.addClass('animated');
                    }
                }).bind($counterNotAnimated))
                .trigger("scroll");
        }
    }

    /**
     * Circle Progress
     * @description Enable Circle Progress plugin
     */
    if (plugins.circleProgress.length) {
        console.error('circleProgress was removed', window.location.href, plugins.circleProgress)
    }

    /**
     * Linear Progress bar
     * @description  Enable progress bar
     */
    if (plugins.progressLinear.length) {
        console.error('progressLinear was removed', window.location.href, plugins.progressLinear)
    }

    /**
     * Select2
     * @description Enables select2 plugin
     */
    if (plugins.selectFilter.length) {
        console.error('plugin select2 was removed', window.location.href, plugins.selectFilter)
    }

    /**
     * @module       Magnific Popup
     * @author       Dmitry Semenov
     * @see          http://dimsemenov.com/plugins/magnific-popup/
     * @version      v1.0.0
     */
    if (plugins.mfp.length > 0 || plugins.mfpGallery.length > 0) {
        if (plugins.mfp.length) {
            console.error('plugin "Magnific Popup" was removed', window.location.href, plugins.mfp)
        }
        if (plugins.mfpGallery.length) {
            console.error('plugin "Magnific Popup" was removed', window.location.href, plugins.mfpGallery)
        }
    }

    /**
     * Slick carousel
     * @description  Enable Slick carousel plugin
     */
    if (plugins.slick.length) {
        console.error('plugin "Slick slider" was removed', window.location.href, plugins.slick)
    }

    /**
     * RD Calendar
     * @description Enables RD Calendar plugin
     */
    if (plugins.calendar.length) {
        console.error('plugin "RD Calendar" was removed', window.location.href, plugins.calendar)
    }

    /**
     * Bootstrap collapse
     *
     */
    function initBootstrapCollapse() {
        const bootstrapCollapse = $('.calendar-box-list-view');
        if (bootstrapCollapse.length > 0) {
            console.error('legacy "bootstrapCollapse" initialization was removed', window.location.href, bootstrapCollapse)
        }
    }

    initBootstrapCollapse();

    /**
     * RD Range
     * @description Enables RD Range plugin
     */
    if (plugins.rdRange.length && !isNoviBuilder) {
        plugins.rdRange.RDRange({});
    }

    /**
     * Custom Waypoints
     */
    if (plugins.customWaypoints.length && !isNoviBuilder) {
        console.error('plugin "customWaypoints" (scrollTo) was removed', window.location.href, plugins.customWaypoints)
    }

    /**
     *  Vide - v0.5.1
     *  @description jQuery plugin for video backgrounds
     */
    if (plugins.vide.length) {
        console.error('plugin "vide" was removed', window.location.href, plugins.vide)
    }

    /**
     * Material Parallax
     * @description Enables Material Parallax plugin
     */
    if (plugins.materialParallax.length) {
        if (!isNoviBuilder && !isIE && !isMobile) {
            plugins.materialParallax.parallax();

            // heavy pages fix
            $window.on('load', function () {
                setTimeout(function () {
                    $window.scroll();
                }, 500);
            });
        } else {
            for (let i = 0; i < plugins.materialParallax.length; i++) {
                const parallax = $(plugins.materialParallax[i]),
                    imgPath = parallax.data("parallax-img");

                parallax.css({
                    "background-image": 'url(' + imgPath + ')',
                    "background-size": "cover"
                });
            }
        }
    }

});
